import Vue from 'vue';
import Vuex from 'vuex';
import { getUserInfo } from '@/api/account';

Vue.use(Vuex);

export default new Vuex.Store({
  getters: {
    userInfo: state => state.userInfo,
    isLoggedIn: state => {
      // 根据你的应用逻辑判断用户是否登录
      // 例如检查 token 是否存在
      console.log('isLoggedIn:' + state.userInfo);
      // return !!state.userInfo;
      // return !!state.userInfo.token; // 或其他判断逻辑
      return true;
    },
  },
  state: {
    userInfo: {},
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {
    getUserInfo(context) {
      getUserInfo().then(res => {
        if (res.Result) {
          context.commit('SET_USER_INFO', res.DataDict.User);
        } else {
          context.commit('SET_USER_INFO', null);
          sessionStorage.removeItem('user');
        }
      });
    },
  },
  modules: {},
});
